@if (displayToast()) {
  <div id="toast">
    <app-toast
      toastStyle="positive"
      icon="checkmark"
      [text]="successResponse()"
    >
    </app-toast>
  </div>
}
@if (!isLoading() && !getOrgError()) {
  <div id="title--container">
    <h4>Organisation Details</h4>
  </div>
  <hr />
  <div id="org--container">
    <div class="card--container">
      <div class="card">
        <div class="header">
          <div class="card-title">Update Organisation</div>
          <div class="body1">Update your organisation name</div>
        </div>
        <hr class="card-divider" aria-hidden="true" />
        <div class="content">
          <div class="form--container">
            <form [formGroup]="editOrgForm">
              <app-underlined-form-field
                [parentForm]="editOrgForm"
                [field]="orgNameField"
              ></app-underlined-form-field>
              <div class="button--container">
                <app-button
                  label="Update"
                  buttonId="update-btn"
                  (buttonClicked)="onSubmit()"
                  [isDisabled]="
                    isProcessing() ||
                    editOrgForm.invalid ||
                    editOrgForm.pristine
                  "
                  [isProcessing]="isProcessing()"
                >
                </app-button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="header">
          <div class="card-title">Licence & Usage</div>
          <div class="body1">Your plan and current allocation</div>
        </div>
        <hr class="card-divider" aria-hidden="true" />
        <div class="content">
          <div class="licence-card--container">
            <app-licence-card
              label="Licence type"
              [value]="LicenseDisplay[organisation().licenseType]"
            >
              @if (currentUser.role | roleCheck: ogiSuperAdminOnly) {
                <app-mat-icon-button
                  iconName="edit"
                  ariaLabel="Edit licence type"
                  (buttonClicked)="openModal('edit-licence-type')"
                ></app-mat-icon-button>
              }
            </app-licence-card>
            <app-licence-card
              label="Number of devices"
              [currentValue]="organisation().numberOfDevices"
              [maxValue]="licenseLimits[organisation().licenseType].maxDevices"
            ></app-licence-card>
            <app-licence-card
              label="Number of users"
              [currentValue]="organisation().numberOfUsers"
              [maxValue]="licenseLimits[organisation().licenseType].maxUsers"
            ></app-licence-card>
          </div>
        </div>
      </div>
    </div>
    <div class="members-labs">
      <div class="header">
        <div class="card-title">Members & Laboratories</div>
        <div class="body1">People and labs in this organisation</div>
      </div>
      <hr class="card-divider" aria-hidden="true" />
      <div class="members-labs--container">
        <div id="nav--container">
          <app-alt-option-tab-toggle
            id="toggle--container"
            groupName="navigationToggle"
            [selectOptions]="navOptions"
            type="round"
            [currentValue]="selectedTabOption()"
            (currentValueChange)="selectedTabOption.set($event)"
          >
          </app-alt-option-tab-toggle>
        </div>
        <app-icon-button
          iconName="add_circle"
          buttonId="add-lab-btn"
          buttonStyle="secondary"
          (buttonClicked)="addLabButtonClicked()"
          buttonShape="square"
          label="Add Laboratory"
          [isDisabled]="!(currentUser.role | roleCheck: superAdminRoles)"
        >
        </app-icon-button>
      </div>
      <div class="content--container">
        @if (selectedTabOption() === "members") {
          @if (!hasUsers() && membersTableLoading()) {
            <div id="loading--container">
              <app-loading-spinner></app-loading-spinner>
            </div>
          }
          @if (!membersTableLoading() || hasUsers()) {
            <div id="inner-page--container">
              <p id="members-table-description" class="table-description">
                User table
              </p>
              <div id="table--container">
                <table
                  mat-table
                  [dataSource]="users()"
                  aria-describedby="members-table-description"
                >
                  <ng-container matColumnDef="firstName">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      scope="col"
                      tabindex="0"
                      [class.active]="currentSort().sortBy === 'FirstName'"
                      [attr.aria-sort]="
                        currentSort().sortBy === 'FirstName'
                          ? currentSort().sortDirection === 'asc'
                            ? 'ascending'
                            : 'descending'
                          : 'none'
                      "
                      (click)="onSort('FirstName')"
                      (keydown.enter)="onSort('FirstName')"
                      (keydown.space)="
                        onSort('FirstName'); $event.preventDefault()
                      "
                    >
                      <div class="table-header">
                        <span>First Name</span>
                        <mat-icon aria-hidden="true">swap_vert</mat-icon>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let user">
                      {{ user.firstName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="lastName">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      scope="col"
                      tabindex="0"
                      [class.active]="currentSort().sortBy === 'LastName'"
                      [attr.aria-sort]="
                        currentSort().sortBy === 'LastName'
                          ? currentSort().sortDirection === 'asc'
                            ? 'ascending'
                            : 'descending'
                          : 'none'
                      "
                      (click)="onSort('LastName')"
                      (keydown.enter)="onSort('LastName')"
                      (keydown.space)="
                        onSort('LastName'); $event.preventDefault()
                      "
                    >
                      <div class="table-header">
                        <span>Last Name</span>
                        <mat-icon aria-hidden="true">swap_vert</mat-icon>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      scope="col"
                      tabindex="0"
                      [class.active]="currentSort().sortBy === 'UserEmail'"
                      [attr.aria-sort]="
                        currentSort().sortBy === 'UserEmail'
                          ? currentSort().sortDirection === 'asc'
                            ? 'ascending'
                            : 'descending'
                          : 'none'
                      "
                      (click)="onSort('UserEmail')"
                      (keydown.enter)="onSort('UserEmail')"
                      (keydown.space)="
                        onSort('UserEmail'); $event.preventDefault()
                      "
                    >
                      <div class="table-header">
                        <span>Email</span>
                        <mat-icon aria-hidden="true">swap_vert</mat-icon>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let user">{{ user.email }}</td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      <div class="table-header"><span>Status</span></div>
                    </th>
                    <td mat-cell *matCellDef="let user" class="status-cell">
                      @if (user.userStatus != null) {
                        <app-status-indicator
                          [status]="UserStatusPrimaryDisplay[user.userStatus]"
                        ></app-status-indicator>
                        @if (UserStatusSecondaryLabel[user.userStatus]) {
                          <span
                            class="status-secondary"
                            [class.status-secondary--expired]="
                              user.userStatus ===
                                UserStatus.AwaitingConfirmationExpired ||
                              user.userStatus ===
                                UserStatus.PendingUpdateEmailConfirmationExpired
                            "
                            >{{
                              UserStatusSecondaryLabel[user.userStatus]
                            }}</span
                          >
                        }
                        @if (user.isLockedOut) {
                          <span
                            class="status-secondary status-secondary--locked"
                            >Account locked</span
                          >
                        }
                        @if (user.isDisabled) {
                          <span
                            class="status-secondary status-secondary--disabled"
                            >Account disabled</span
                          >
                        }
                        @if (user.twoFactorEnabled) {
                          <span
                            class="status-secondary status-secondary--two-factor"
                            >2FA enabled</span
                          >
                        }
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      <div class="table-header"><span>Role</span></div>
                    </th>
                    <td mat-cell *matCellDef="let user">
                      {{ user.role | formatRole }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="laboratories">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      <div class="table-header"><span>Laboratories</span></div>
                    </th>
                    <td mat-cell *matCellDef="let user">
                      @for (lab of user.labNames; track lab) {
                        <p>{{ lab }}</p>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef scope="col">
                      <div class="table-header"><span>Actions</span></div>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let user"
                      class="button--container"
                      (click)="$event.stopPropagation()"
                    >
                      @if (user.userStatus === UserStatus.Active) {
                        <app-mat-icon-button
                          buttonId="edit-btn"
                          iconName="edit"
                          ariaLabel="Edit User"
                          (buttonClicked)="onEditUser(user.id)"
                          [isDisabled]="
                            !(currentUser.role | roleCheck: superAdminRoles)
                          "
                        ></app-mat-icon-button>
                      }
                      @if (
                        user.userStatus === UserStatus.InviteSent ||
                        user.userStatus === UserStatus.InviteExpired
                      ) {
                        <app-mat-icon-button
                          buttonId="resend-invite-btn"
                          iconName="forward_to_inbox"
                          (buttonClicked)="resendInvite(user.id)"
                          ariaLabel="Resend Invite"
                          [isDisabled]="
                            !(currentUser.role | roleCheck: superAdminRoles)
                          "
                        ></app-mat-icon-button>
                      }
                      @if (
                        user.userStatus === UserStatus.InviteSent ||
                        user.userStatus === UserStatus.InviteExpired
                      ) {
                        <app-mat-icon-button
                          buttonId="delete-invite-btn"
                          buttonStyle="negative"
                          ariaLabel="Delete Invite"
                          iconName="delete"
                          (buttonClicked)="handleInviteDeletion(user.id)"
                          [isDisabled]="
                            !(currentUser.role | roleCheck: superAdminRoles)
                          "
                        ></app-mat-icon-button>
                      }
                      @if (
                        user.userStatus === UserStatus.AwaitingConfirmation ||
                        user.userStatus ===
                          UserStatus.AwaitingConfirmationExpired
                      ) {
                        <app-mat-icon-button
                          buttonId="resend-confirmation-btn"
                          iconName="forward_to_inbox"
                          (buttonClicked)="resendConfirmationEmail(user.id)"
                          ariaLabel="Resend Confirmation Email"
                          [isDisabled]="
                            !(currentUser.role | roleCheck: superAdminRoles)
                          "
                        ></app-mat-icon-button>
                      }
                      @if (
                        user.userStatus ===
                          UserStatus.PendingUpdateEmailConfirmation ||
                        user.userStatus ===
                          UserStatus.PendingUpdateEmailConfirmationExpired
                      ) {
                        <app-mat-icon-button
                          buttonId="resend-update-confirmation-btn"
                          iconName="forward_to_inbox"
                          (buttonClicked)="
                            resendUpdateEmailConfirmation(user.id)
                          "
                          ariaLabel="Resend Confirmation Email"
                          [isDisabled]="
                            !(currentUser.role | roleCheck: superAdminRoles)
                          "
                        ></app-mat-icon-button>
                      }
                      @if (
                        user.userStatus === UserStatus.AwaitingConfirmation ||
                        user.userStatus ===
                          UserStatus.AwaitingConfirmationExpired
                      ) {
                        <app-mat-icon-button
                          buttonId="delete-user-btn"
                          buttonStyle="negative"
                          ariaLabel="Delete User"
                          iconName="delete"
                          (buttonClicked)="handleUserDeletion(user.id)"
                          [isDisabled]="
                            !(currentUser.role | roleCheck: superAdminRoles)
                          "
                        ></app-mat-icon-button>
                      }
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="membersDisplayedColumns"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let user; columns: membersDisplayedColumns"
                    [class.clickable-row]="
                      user.userStatus === UserStatus.Active
                    "
                    [tabindex]="
                      user.userStatus === UserStatus.Active ? 0 : null
                    "
                    (click)="onRowClick(user)"
                    (keydown.enter)="onRowClick(user)"
                  ></tr>
                  <tr *matNoDataRow>
                    <td
                      [attr.colspan]="membersDisplayedColumns.length"
                      id="empty-state"
                    >
                      <mat-icon id="empty-state--icon">group</mat-icon>
                      <p id="empty-state--title">
                        {{
                          getOrgUsersError()
                            ? getOrgUsersError().message
                            : organisation().organisationName +
                              " does not have any members."
                        }}
                      </p>
                    </td>
                  </tr>
                </table>
                @if (hasUsers()) {
                  <div id="pagination--container">
                    <div class="filter--container">
                      <label for="users-per-page">Users per page</label>
                      <app-dropdown-form-field
                        id="users-per-page"
                        [field]="usersPerPageField"
                        [parentForm]="usersTableControls"
                      >
                      </app-dropdown-form-field>
                    </div>
                    <div id="pagination--controls">
                      <app-icon-button
                        iconName="chevron_left"
                        buttonId="previous"
                        (buttonClicked)="getPrevious()"
                        [isDisabled]="!hasPrevious()"
                      ></app-icon-button>
                      <span> {{ currentPage() }} / {{ totalPages() }} </span>
                      <app-icon-button
                        iconName="chevron_right"
                        buttonId="next"
                        (buttonClicked)="getNext()"
                        [isDisabled]="!hasNext()"
                      ></app-icon-button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
        @if (selectedTabOption() === "labs") {
          <p id="labs-table-description" class="table-description">
            Laboratories table
          </p>
          <div id="table--container">
            <table
              mat-table
              [dataSource]="organisation().labSummary ?? []"
              aria-describedby="labs-table-description"
            >
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef scope="col">
                  <div class="table-header"><span>Name</span></div>
                </th>
                <td mat-cell *matCellDef="let lab">{{ lab.laboratoryName }}</td>
              </ng-container>
              <ng-container matColumnDef="errorLogCount">
                <th mat-header-cell *matHeaderCellDef scope="col">
                  <div class="table-header"><span>Total Error Log</span></div>
                </th>
                <td mat-cell *matCellDef="let lab">
                  {{ lab.totalErrorLogCount }}
                </td>
              </ng-container>
              <ng-container matColumnDef="unviewedErrorLogCount">
                <th mat-header-cell *matHeaderCellDef scope="col">
                  <div class="table-header">
                    <span>Unviewed Error Log</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let lab">
                  {{ lab.unviewedErrorLogCount }}
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef scope="col">
                  <div class="table-header"><span>Status</span></div>
                </th>
                <td mat-cell *matCellDef="let lab">
                  <app-status-indicator
                    [status]="lab.isDeleted ? 'Deleted' : 'Active'"
                  ></app-status-indicator>
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef scope="col">Actions</th>
                <td mat-cell *matCellDef="let lab">
                  <app-mat-icon-button
                    buttonId="view-lab-btn"
                    iconName="arrow_forward"
                    (buttonClicked)="onViewLab(lab)"
                    ariaLabel="View Lab"
                  ></app-mat-icon-button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="labsDisplayedColumns()"></tr>
              <tr
                mat-row
                *matRowDef="let lab; columns: labsDisplayedColumns()"
                class="clickable-row"
                tabindex="0"
                (click)="onViewLab(lab)"
                (keydown.enter)="onViewLab(lab)"
              ></tr>
              <tr *matNoDataRow>
                <td
                  [attr.colspan]="labsDisplayedColumns().length"
                  id="empty-state"
                >
                  <mat-icon id="empty-state--icon">science</mat-icon>
                  <p id="empty-state--title">
                    {{ organisation().organisationName }} does not have any
                    labs.
                  </p>
                </td>
              </tr>
            </table>
          </div>
        }
      </div>
    </div>
    <div class="action-card--container">
      @if (currentUser.role | roleCheck: superAdminRoles) {
        <app-button-card
          cardStyle="warning"
          title="Require two-factor authentication"
          bodyLine1="Every member of this organisation will be required to set up 2FA "
          bodyLine2="the next time they sign in. This applies immediately."
          iconName="logout"
          toggleId="require-2fa-toggle"
          controlType="toggle"
          [toggleValue]="require2FAToggle()"
          [isDisabled]="!(currentUser.role | roleCheck: superAdminRoles)"
          (toggleChanged)="onRequire2FAChanged($event)"
        ></app-button-card>
      }
      @if (currentUser.role | roleCheck: ogiSuperAdminOnly) {
        <app-button-card
          id="delete-org-card"
          cardStyle="negative"
          title="Delete organisation"
          bodyLine1="Permanently removes your organisation & all associated data."
          bodyLine2="This action cannot be undone."
          buttonLabel="Delete organisation"
          buttonId="delete-org-btn"
          iconName="delete"
          [isDisabled]="!(currentUser.role | roleCheck: ogiSuperAdminOnly)"
          (buttonClicked)="openModal('delete-organisation')"
        ></app-button-card>
      }
    </div>
  </div>
} @else if (isLoading()) {
  <div id="full-page-loading--container">
    <app-loading-spinner></app-loading-spinner>
  </div>
} @else if (getOrgError()) {
  <app-error-page [primaryText]="getOrgError()?.message"></app-error-page>
}
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error()?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="closeModal('error')"
></app-modal>
<app-validation-modal
  id="delete-organisation"
  titleText="Delete organisation"
  validationText="delete"
  primaryButtonText="Delete"
  primaryButtonId="primary-button"
  secondaryButtonText="Close"
  secondaryButtonId="secondary-button"
  (modalButtonClicked)="deleteOrganisation()"
  [error]="error()"
></app-validation-modal>
<app-validation-modal
  id="delete-invite"
  titleText="Delete Invite"
  primaryText="Are you sure you want to delete this invite?"
  validationText="delete"
  primaryButtonText="Delete Invite"
  primaryButtonId="delete-invite"
  secondaryButtonText="Close"
  secondaryButtonId="close-delete-invite"
  (modalButtonClicked)="inviteModalButtonClicked($event)"
  [error]="error()"
></app-validation-modal>
<app-validation-modal
  id="delete-user"
  titleText="Delete User"
  primaryText="Are you sure you want to delete this user?"
  validationText="delete"
  primaryButtonText="Delete User"
  primaryButtonId="delete-user"
  secondaryButtonText="Close"
  secondaryButtonId="close-delete-user"
  (modalButtonClicked)="inviteModalButtonClicked($event)"
  [error]="error()"
></app-validation-modal>
<app-modal
  id="disable-2fa"
  titleText="Disable Two-Factor Authentication"
  primaryText="Users will no longer be asked for a two-factor code when signing in. Existing authenticator setup and recovery codes will remain stored."
  buttonLayout="double-button"
  primaryButtonText="Confirm"
  primaryButtonId="confirm-require-2fa"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-require-2fa"
  [isProcessing]="require2FAProcessing()"
  (modalButtonClicked)="onRequire2FAModalButtonClicked($event)"
></app-modal>
<app-validation-modal
  id="require-2fa-validation"
  titleText="Two-Factor Authentication"
  primaryText="Are you sure you want to change the two-factor authentication requirement?"
  validationText="enable"
  primaryButtonText="Confirm"
  primaryButtonId="confirm-require-2fa"
  secondaryButtonText="Close"
  secondaryButtonId="cancel-require-2fa"
  (modalButtonClicked)="onRequire2FAModalButtonClicked($event)"
  [error]="error()"
></app-validation-modal>
<app-edit-licence-type-modal
  id="edit-licence-type"
  [currentLicenceType]="organisation()?.licenseType"
  [numberOfUsers]="organisation()?.numberOfUsers"
  [numberOfDevices]="organisation()?.numberOfDevices"
  [processing]="editLicenceTypeProcessing()"
  (licenceTypeConfirmed)="onLicenceTypeConfirmed($event)"
></app-edit-licence-type-modal>
